import BookmarkIcon from "@heroicons/react/24/outline/BookmarkIcon";
import ClockIcon from "@heroicons/react/24/outline/ClockIcon";
import CurrencyDollarIcon from "@heroicons/react/24/outline/CurrencyDollarIcon";
import MapPinIcon from "@heroicons/react/24/outline/MapPinIcon";
import InformationCircleIcon from "@heroicons/react/24/solid/InformationCircleIcon";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../../assets/colors";

export const CardStyled = styling("div")((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  boxShadow: "0 0 0 rgb(181 181 181 / 20%)",
  border: `1.5px solid ${Color.grey}`,
  borderRadius: "10px",

  padding: "1.5rem",
  height: "100%",

  "@media (max-width: 1279px)": {
    padding: "1.75rem 1rem",
  },

  "@media (max-width: 767px)": {
    padding: "1rem 1.5rem",
    minHeight: "8.3125rem",
  },
}));

export const IconTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "1rem",

  color: "rgba(0, 0, 0, 0.6)",
}));

export const BoxStyled = styling(Box)((props) => ({
  display: "flex",
}));

export const MapPinStyled = styling(MapPinIcon)((props) => ({
  width: "24px",
  height: "24px",
  overflow: "visible",
}));

export const CurrencyIconStyled = styling(CurrencyDollarIcon)((props) => ({
  width: "24px",
  height: "24px",
  overflow: "visible",
}));

export const LabelStyled = styling(Typography)((props) => ({
  lineHeight: "1.4",
  letterSpacing: "0.05rem",
  textWrap: "wrap",

  "@media (max-width: 767px)": {
    fontSize: "14px",
  },
}));

export const StatusBadgeContainer = styling("div")((props) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  color: props.$color || Color.black,
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
  whiteSpace: "nowrap",
}));

export const StatusClockIcon = styling(ClockIcon)({
  width: "15px",
  height: "15px",
});


export const DivStyled = styling(Grid)((props) => ({
  //
}));

// SingleJobHighlightWithLogo START STYLE

export const CardStyledWithLogo = styling(Card)((props) => ({
  borderRadius: "10px",
  padding: "24px",
  border: `1px solid ${Color.grey}`,
  height: "100%",
  boxShadow: "0 0 0 rgb(181 181 181 / 20%)",
  height: "fit-content",
}));

export const CardContentStyledWithLogo = styling(CardContent)((props) => ({
  padding: "0px !important",
}));

export const CompanyLogoImgStyled = styling("img")((props) => ({
  borderRadius: "8px",
  width: "65px",
  height: "65px",
  objectFit: "contain",
}));

export const JobTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  lineHeight: "24px",
  fontSize: "20px",
  color: Color.black,
  marginBottom: "8px",
}));

export const LinkStyled = styling(Link)((props) => ({
  color: props["aria-disabled"] ? Color.black : Color.hiredlyPurple,
  pointerEvents: props["aria-disabled"] ? "none" : "auto",
  textDecoration: props["aria-disabled"] ? "none" : "underline",
  textDecorationColor: Color.hiredlyPurple,
}));

export const ApplyJobButton = styling(Button)((props) => ({
  textTransform: "capitalize",
  backgroundColor: Color.buttonGreen,
  border: `1.5px solid ${Color.black}`,
  minWidth: "75%",
  height: "48px",
  borderRadius: "100px",
  fontWeight: "700",
  color: Color.white,
  fontSize: "16px",

  "&:hover": {
    backgroundColor: Color.buttonHoverGreen,
  },
}));

export const IconButtonStyled = styling(IconButton)((props) => ({
  width: "47px",
  height: "47px",
  border: `1.5px solid ${Color.black}`,
  color: Color.black,

  "&:hover": {
    backgroundColor: Color.lightGrey,
  },
}));

export const BookmarkIconStyled = styling(BookmarkIcon)({
  width: "24px",
  height: "24px",
});

// SingleJobHighlightWithLogo END STYLE

export const InfoCirleFilledStyled = styling(InformationCircleIcon)({
  margin: "2px",
  width: "10px",
  height: "10px",
});

export const StyledTooltip = styling(Tooltip)({
  display: "flex",
  padding: "2px 8px",
  justifyContent: "center",
  gap: "4px",
  alignItems: "center",
  borderRadius: "50px",
  background: "rgba(242, 175, 41, 0.30)",
  height: "fit-content",
  width: "fit-content",
});

export const StyledTooltipText = styling(Typography)({
  color: "rgba(0, 0, 0, 0.87)",
  fontFamily: "Inter",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",

  textWrap: "nowrap",
});

export const TooltipInfoText = styling(Typography)({
  alignSelf: "stretch",
  color: "#000000DE",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
});
